export default {
  serviceUri: process.env.VUE_APP_SERVICE_URI,
  gRecaptcha: {
    siteKey: process.env.VUE_APP_GRECAPTCHA_SITEKEY
  }
}